import {
  Breakpoints,
  CTA,
  Layout,
  Text,
  TokenTextAppearance
} from "@volkswagen-onehub/components-core";
import React, { ReactElement } from 'react';
import styled from "styled-components";
import { LoginByVinErrorPageViewProps } from "./LoginByVinErrorPageViewProps";
import { ContactMeUrl } from "../../modules/navigation/ExternalLinks";

const StyledHeadline = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.dynamic0150};
`;
const StyledText = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.dynamic0250};
`;

const StyledCTA = styled(CTA)`
  width: 100%;
  max-width: 150px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0100};
  align-items: center;

  @media (min-width: ${Breakpoints.b560}px) {
    align-items: flex-start;
  }
`;

export function LoginByVinErrorPageVwView({ onClick }: LoginByVinErrorPageViewProps): ReactElement {
  return (
    <Layout allowOverflowingContent>
      <Text appearance={TokenTextAppearance.headline400}>We could not find</Text>
      <StyledHeadline appearance={TokenTextAppearance.headline400} bold>
        your vehicle details
      </StyledHeadline>
      <StyledText appearance={TokenTextAppearance.copy200}>Would you like to contact us to make a booking?</StyledText>
      <ButtonsContainer>
        <StyledCTA
          tag="a"
          href={ContactMeUrl}
          stretchContent={{
            [Breakpoints.default]: true,
            [Breakpoints.b560]: false,
          }}>
          Contact Me
        </StyledCTA>
        <StyledCTA
          tag="button"
          emphasis="secondary"
          onClick={onClick}
          stretchContent={{
            [Breakpoints.default]: true,
            [Breakpoints.b560]: false,
          }}>
          Try again
        </StyledCTA>
      </ButtonsContainer>
    </Layout>
  );
}
